import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18N } from '@/shared/legacy/lib/use-i18n';
import BasePromoBadge from '@/shared/ui/base-promo-badge/base-promo-badge.vue';

type Props = {
  tariffGroup: any;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'tariff-badge',
  props: {
    tariffGroup: {}
  },
  setup(__props: any) {



const i18n = useI18N();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePromoBadge, {
    text: _unref(i18n)('tariff', __props.tariffGroup)
  }, null, 8, ["text"]))
}
}

})